import { render } from "./TemperaturesByTime.vue?vue&type=template&id=54adbd10&scoped=true"
import script from "./TemperaturesByTime.vue?vue&type=script&lang=js"
export * from "./TemperaturesByTime.vue?vue&type=script&lang=js"

import "./TemperaturesByTime.vue?vue&type=style&index=0&id=54adbd10&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54adbd10"]])

export default __exports__